import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { meQueryOptions } from '~/api/auth';
import { isApiError } from '~/api/client';
import { Shell } from '~/app/Shell';

/**
 * Every signed-in screen lives under this pathless layout. It loads the boot
 * payload once; a 401 sends the person to sign in and brings them back after.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    let role: string | undefined;
    try {
      role = (await context.queryClient.ensureQueryData(meQueryOptions)).person.role;
    } catch (error) {
      if (isApiError(error) && error.status === 401) {
        throw redirect({ to: '/login', search: { next: location.href } });
      }
      throw error;
    }
    // Someone from outside the company uses only the Order Tracker, and their own settings.
    if (
      role === 'guest' &&
      !location.pathname.startsWith('/orders') &&
      !location.pathname.startsWith('/settings')
    ) {
      throw redirect({ to: '/orders' });
    }
  },
  component: () => (
    <Shell>
      <Outlet />
    </Shell>
  ),
});
